import React, { Fragment } from 'react';
import classnames from 'classnames';
import colorVariables from '@densityco/ui/variables/colors.json';

import Chip from '../Chip';
import Tooltip from '../Tooltip';
import {
  Sensor,
  SensorType,
} from '../../types/api';

type DataCaptureStatusTagProps = {
  sensor: Sensor;
}

const DataCaptureStatusTag: React.FunctionComponent<DataCaptureStatusTagProps> = ({sensor}) => {
  if (sensor.sensor_type === SensorType.OB1) {
    return (
      <Tooltip
        contents="OA sensors do not support data capture."
        target={<span style={{cursor: 'help'}}>
          <Chip color={colorVariables.gray300}>N/A</Chip>
        </span>}
      />
    );
  }
  const captureStatus = sensor.diagnostic_info_json.capture_status;
  if (!captureStatus) {
    return (
      <Tooltip
        contents="This sensor isn't running a new enough os version."
        target={<span style={{cursor: 'help'}}>
          <Chip color={colorVariables.gray300}>Unknown</Chip>
        </span>}
      />
    );
  }
  return (
    <span>
      {captureStatus.finished ? (
        <Chip>Not capturing</Chip>
      ) : (
        <Fragment>
          <Chip
            backgroundColor={colorVariables.blue}
            color="#fff"
          >Capturing</Chip>
          <br/>
          {captureStatus.num_captures ? (
            <small>
              {captureStatus.current_upload} so far / max {captureStatus.num_captures}
            </small>
          ) : (
            <small>
              {captureStatus.current_upload} {captureStatus.current_upload === 1 ? 'capture' : 'captures'} so far
            </small>
          )}
        </Fragment>
      )}
    </span>
  );
};

export default DataCaptureStatusTag;
